import React from "react";
import { Search } from "lucide-react";

/**
 * Placeholder Circa Social search surface (bottom-nav entry).
 * Real search UI lands later.
 */
export default function SocialSearchPage() {
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-3 px-6 py-16 text-center">
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-muted text-muted-foreground">
        <Search className="h-6 w-6" aria-hidden />
      </div>
      <h1 className="text-lg font-semibold tracking-tight">Search</h1>
      <p className="max-w-sm text-sm text-muted-foreground">
        Search coming soon.
      </p>
    </div>
  );
}
